export enum HomeActionTypes {
  SET_LOADING_STATUS = '@@home/SET_LOADING_STATUS',
  SET_COOPERATIVES = '@@home/SET_COOPERATIVES',
  SET_MENU_CONFIG = '@@home/SET_MENU_CONFIG',
}
